import React from "react";
import RiskTable from "./view/RiskTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const Risk = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_risk_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div>
      {userPermissions.includes(viewPermission) ? (
        <>
          <RiskTable />
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Risk;
